export const FINANCING_TERMS_PATH = '/financing';

export const routePaths = {
  FINANCING_TERMS_PATH
};

export default routePaths;
